const SharedModels = require('../../../shared/sharedModels');

exports.deleteValueFromArray = function(value, array){
   for(let i = 0; i < array.length; i++){
      if(array[i] == value){
         array.splice(i,1);
         break;
      }
   }
};

class RecentCardManager{
   constructor(){
      this.evidenceCards = [];
   }

   loadData(data){
      this.evidenceCards = [];

      if(data.evidenceCards){
         for(let card of data.evidenceCards){
            this.evidenceCards.push(new SharedModels.EvidenceCard(card));
         }
      }
   }

   exportData(){
      let idArray = [];
      for(let card of this.evidenceCards){
         idArray.push(card.idEvidenceCard);
      }
      return idArray.toString();
   }

   parseExportStringToArray(string){
      let parsed = string.split(',');
      for(let i = 0; i < parsed.length; i++){
         parsed[i] = parseInt(parsed[i]);
      }
      return parsed;
   }

   pushEvidenceCard(eCard){
      let idEvidenceCard = eCard.idEvidenceCard
      let index = -1;
      for(let i = 0; i < this.evidenceCards.length; i++){
         if(this.evidenceCards[i].idEvidenceCard == idEvidenceCard){
            index = i;
            break;
         }
      }
      if(index === -1){
         this.evidenceCards.push(new SharedModels.EvidenceCard(eCard));
         if(this.evidenceCards.length > 20){
            this.evidenceCards.shift();
         }
         return true;
      }
      else{
         return false;
      }

   }
}

let managerInstance = new RecentCardManager();
exports.RecentCardManager = managerInstance;
